import React from 'react'
import cx from 'classnames'
import DropdownContainer, { ToggleDropdown } from 'components/layout/DropdownContainer'
import Icon from 'components/shared/Icon'
import { useSelector } from 'react-redux'
import selectAvailableAol from 'redux/selectors/selectAvailableAol'
import selectAolName from 'redux/selectors/selectAolName'
import { capitalize } from 'libraries/lodash'

const AolSelectorDesktop = () => {
  const aol = useSelector(selectAolName)
  const availableAol = useSelector(selectAvailableAol).slice(1) // remove blank aol

  return (
    <ToggleDropdown dropdownId='aol-selector-dropdown'>
      <div className='w13 flex justify-center mr8'>
        <div className='flex relative pointer f4 fw6 bb-medium b--transparent hover-b--black'>
          {capitalize(aol)}
          <Icon name='icon-menu-down' className='w7' />
          <DropdownContainer id='aol-selector-dropdown' className='z35 absolute center-h top7 bg-white shadow-black-1 mt6'>
            <ul className='flex flex-column items-center list-reset pa0 ma0'>
              {availableAol.map(({ name, urlFragment }, index) => (
                <li key={index} className={cx('w-100 hover-bg-ghost-grey flex', { bb: index < availableAol.length - 1 })}>
                  <a className='ph6 pv5 no-underline black grow-1 fw5' href={`${urlFragment}`}>
                    {capitalize(name)}
                  </a>
                </li>
              ))}
            </ul>
          </DropdownContainer>
        </div>
      </div>
    </ToggleDropdown>
  )
}

export default AolSelectorDesktop
